module.exports = __webpack_public_path__ + "img/parrainage.a4952f4d.gif";